import React from 'react';
import Slider from 'react-slick';
import { SubHeading } from './subHeading';
import { AddButton } from './addButton';
import { Link } from 'react-router-dom';
import { SimpleImg } from 'react-simple-img';
import Banners from '../data/data.json';

var settings = {
  dots: false,
  arrows: false,
  swipeToSlide: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  variableWidth: true
};

export const SlideFull = props => {
  let slides = [];
  switch (props.type) {
    case 'diamond':
      slides = Banners.products.filter(item => item.categ === 'diamond');
      break;
    case 'gold':
      slides = Banners.products.filter(item => item.categ === 'gold');
      break;
  }

  return (
    <>
      <SubHeading title={props.cat} />
      <div className="h-slider h-slider--diff">
        <Slider {...settings}>
          {slides.map(banners => {
            return (
              <div key={banners.id} className="item">
                <Link
                  to={{
                    pathname: `product-page/${banners.id}`,
                    query: { id: banners.id }
                  }}
                >
                  <SimpleImg
                    height={125}
                    src={banners.img}
                    alt={banners.alt}
                    placeholder="#f2f2f2"
                  />
                </Link>
                <div className="center-flexed">
                  <div>
                    <div className="item-name">{banners.alt}</div>
                    <div className="item-price">$ {banners.price}</div>
                  </div>
                  <AddButton pd={banners} className="round" btnText="+" />
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </>
  );
};
